import template from './reports.html';
import controller from './reports.controller';
import './reports.styl';

let reportsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default reportsComponent;



// WEBPACK FOOTER //
// ./client/app/components/reports/reports.component.js